module.exports = __webpack_public_path__ + "img/1725845530048-screenshot-1725845501914.png.362f01fa.webp";